var _path, _path2, _path3, _path4, _path5, _g, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastshift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 182,
    viewBox: "0 0 262 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.364 0.998047H24.6364C11.5824 0.998047 1 11.743 1 24.9975V156.994C1 170.249 11.5824 180.994 24.6364 180.994H237.364C250.418 180.994 261 170.249 261 156.994V24.9975C261 11.743 250.418 0.998047 237.364 0.998047Z",
    fill: "white",
    stroke: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.565 74.5042H153.091C149.215 74.5042 147.402 77.2299 146.717 80.8518L146.276 83.2027H153.012L151.838 89.4182H145.102L140.674 112.832H132.307L136.735 89.4182H130.676L131.85 83.2027H137.901L138.342 80.8518C139.973 72.2194 145.575 67.084 154.485 67.084H157.96L156.557 74.5116L156.565 74.5042Z",
    fill: "#394187"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.212 90.7478C156.11 85.9871 162.255 81.9316 168.582 81.9316C174.57 81.9316 180.211 84.4663 179.203 91.2547H171.308C171.592 89.036 169.433 88.2132 167.597 88.2132C165.557 88.2132 163.445 88.9111 163.028 91.1298C162.799 92.3347 164.146 93.1575 165.896 93.6057L170.977 94.8105C177.989 96.5885 178.045 101.349 177.596 103.693C176.453 109.724 169.472 112.832 162.87 112.832C156.614 112.832 150.887 109.276 151.958 102.87H159.719C159.529 104.964 161.775 106.742 164.863 106.609C167.188 106.551 169.252 105.346 169.575 103.627C169.929 102.099 168.85 101.342 166.628 100.835L162.468 99.8136C154.629 97.7198 154.542 94.2301 155.204 90.7404",
    fill: "#394187"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5469 71.3384L103.737 87.9936L123.52 78.4869L98.2215 62.9925C95.7791 61.5011 93.0923 60.8105 90.4608 60.8105C84.0711 60.8105 77.9966 64.8733 76.5391 71.3384H76.5469Z",
    fill: "url(#paint0_linear_216_58)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_216_58",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 78,
    width: 60,
    height: 46
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5786 95.7512C75.8707 101.379 67.4954 111.628 64.793 123.647L119.251 97.4924L123.521 78.4863L87.5707 95.7512H87.5786Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_216_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.521 78.4863H64.793V123.647H123.521V78.4863Z",
    fill: "url(#paint1_linear_216_58)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.01 67.0848C187.679 67.0848 187.372 66.9526 187.135 66.7322C186.71 66.3208 186.655 65.6522 187.002 65.1673L190.098 60.9503L184.961 60.4654C184.401 60.4139 183.937 60.0613 183.763 59.5323C183.582 59.0033 183.732 58.4523 184.149 58.0777L192.139 51.0835C192.367 50.8852 192.666 50.7676 192.974 50.7676C193.305 50.7676 193.62 50.8926 193.856 51.1277C194.282 51.5317 194.337 52.2076 193.982 52.6852L190.886 56.9022L196.023 57.387C196.582 57.4384 197.047 57.7985 197.228 58.3274C197.409 58.849 197.26 59.4074 196.834 59.7747L188.845 66.7689C188.625 66.9672 188.325 67.0848 188.01 67.0848Z",
    fill: "#DB179E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_216_58",
    x1: 79.2572,
    y1: 61.0603,
    x2: 136.827,
    y2: 105.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8C1B9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#7D1CA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5920B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2A26D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_216_58",
    x1: 78.8172,
    y1: 108.983,
    x2: 123.259,
    y2: 82.6261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5327F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BC277F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87197E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastshift);
export default __webpack_public_path__ + "static/media/fastshift.c0c1c328f7d75ac68d0b2ea18d0abb37.svg";
export { ForwardRef as ReactComponent };